<template>
	<div class="highlight" v-html="highlightedText"></div>
</template>

<script>
export default {
	name: "SearchResultHighlight",
	props: ["textToHighlight", "searchPhrase"],
	computed: {
		highlightedText: function () {
			if (!this.textToHighlight || !this.searchPhrase) return;
			let text = this.textToHighlight;
			let phrRegexp = new RegExp(
				this.escapeRegExp(this.searchPhrase),
				"i"
			);

			let matches = phrRegexp.exec(text);
			let matchCache = [];
			let counter = 0;

			while (matches) {
				matchCache.push(`<span class="hl">${matches[0]}</span>`);
				text = text.replace(phrRegexp, `***${counter}***`);
				counter++;
				matches = phrRegexp.exec(text);
			}

			matchCache.forEach((m, i) => {
				text = text.replace(`***${i}***`, m);
			});

			return text;
		},
	},
	methods: {
		escapeRegExp: function (string) {
			return string.replace(/[.*+\-?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
		},
	},
};
</script>

<style>
.highlight p {
	padding: 0 !important;
}
</style>